module.exports = __webpack_public_path__ + "static/media/tjyhk_qx.46d0fd0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/tjyhk_qx.png
// module id = 2179
// module chunks = 0